import { PropsWithChildren, useContext, useEffect } from 'react';
import { Crisp } from 'crisp-sdk-web';

import AuthorizationContext from 'packages/kakapo-ui-application/contexts/AuthorizationContext';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';
import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';

export default function HelpdeskContainer(props: PropsWithChildren<{}>) {
	const context = useContext(AuthorizationContext);
	const workspace = useWorkspace();
	const { loading, isWorkspaceSuperuser } = useViewerRoles();

	useEffect(() => {
		Crisp.configure('e47a78ed-aa11-455a-842a-901ffda09cd5');
		// Sentry overrides the document.addEventListener and document.removeEventListener to catch errors.
		// This causes Crisp to return a warning in the console which can be ignored.
		// By setting safe mode to true, Crisp will not warn about this. If crisp ever breaks, this should be the first thing to check.
		Crisp.setSafeMode(true);
	}, []);

	useEffect(() => {
		if (loading) {
			return;
		}

		if (context?.authenticatedUser) {
			const { signedEmail, firstName, lastName } = context.authenticatedUser;
			Crisp.user.setCompany(workspace.id, {});
			Crisp.user.setNickname(`${firstName} ${lastName}`);

			if (signedEmail) {
				Crisp.user.setEmail(signedEmail.email, signedEmail.hmac);
			}
		}
	}, [
		!!context,
		!!context?.authenticatedUser,
		context?.authenticatedUser.privacyConsent?.version,
		loading,
		isWorkspaceSuperuser,
	]);

	return <>{props.children}</>;
}
